module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kMuhk"))).then(() => parcelRequire('fThBo'));